import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'

export default function Usuarios() {
  const [usuarios, setUsuarios] = useState([])
  const [edificios, setEdificios] = useState([])
  const [showForm, setShowForm] = useState(false)
  const [form, setForm] = useState({ email: '', nombre: '', rol: 'recepcionista', edificio_id: '', password: '' })
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => { fetchUsuarios(); fetchEdificios() }, [])

  const fetchUsuarios = async () => {
    const { data } = await supabase.from('usuarios').select('*, edificios(nombre)').order('nombre')
    setUsuarios(data || [])
  }

  const fetchEdificios = async () => {
    const { data } = await supabase.from('edificios').select('*')
    setEdificios(data || [])
  }

  const handleCreate = async () => {
    if (!form.email || !form.nombre || !form.password) return
    setLoading(true)
    setError(null)

    // Crear auth user en Supabase
    const { data: authData, error: authError } = await supabase.auth.admin.createUser({
      email: form.email,
      password: form.password,
      email_confirm: true
    })

    if (authError) {
      setError('Error al crear el usuario: ' + authError.message)
      setLoading(false)
      return
    }

    // Crear registro en tabla usuarios
    await supabase.from('usuarios').insert({
      email: form.email,
      nombre: form.nombre,
      rol: form.rol,
      edificio_id: form.rol === 'admin' ? null : form.edificio_id || null,
    })

    setSuccess('Usuario creado correctamente')
    setTimeout(() => setSuccess(null), 3000)
    setShowForm(false)
    setForm({ email: '', nombre: '', rol: 'recepcionista', edificio_id: '', password: '' })
    fetchUsuarios()
    setLoading(false)
  }

  const handleToggle = async (u) => {
    await supabase.from('usuarios').update({ activo: !u.activo }).eq('id', u.id)
    fetchUsuarios()
  }

  return (
    <div className="fade-in">
      {success && (
        <div style={{
          position: 'fixed', top: 24, left: '50%', transform: 'translateX(-50%)',
          background: 'var(--green)', color: 'white', padding: '14px 28px',
          borderRadius: 10, fontWeight: 600, fontSize: 14, zIndex: 9999,
          boxShadow: '0 8px 32px rgba(0,0,0,0.4)', animation: 'slideDown 0.3s ease'
        }}>
          ✓ {success}
        </div>
      )}

      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 32 }}>
        <div>
          <h1 style={{ fontSize: 36, color: 'var(--text)', marginBottom: 4 }}>Usuarios</h1>
          <p style={{ color: 'var(--text3)', fontSize: 14 }}>Recepcionistas y administradores del sistema</p>
        </div>
        <button className="btn btn-gold" onClick={() => setShowForm(!showForm)}>
          {showForm ? '✕ Cancelar' : '+ Nuevo usuario'}
        </button>
      </div>

      {showForm && (
        <div className="card fade-in" style={{ marginBottom: 24, borderColor: 'var(--gold)', borderWidth: 1.5 }}>
          <div style={{ fontSize: 11, color: 'var(--gold)', fontFamily: 'DM Mono, monospace', letterSpacing: 1, marginBottom: 20 }}>
            NUEVO USUARIO
          </div>
          {error && (
            <div style={{ background: 'var(--red-bg)', border: '1px solid rgba(192,57,43,0.3)', borderRadius: 8, padding: '10px 14px', marginBottom: 16, fontSize: 13, color: 'var(--red)' }}>
              {error}
            </div>
          )}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 }}>
            <div>
              <label style={{ display: 'block', fontSize: 11, color: 'var(--text3)', marginBottom: 6 }}>NOMBRE</label>
              <input className="input" placeholder="Nombre completo" value={form.nombre} onChange={e => setForm(f => ({ ...f, nombre: e.target.value }))} />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: 11, color: 'var(--text3)', marginBottom: 6 }}>EMAIL</label>
              <input className="input" type="email" placeholder="email@ejemplo.com" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: 11, color: 'var(--text3)', marginBottom: 6 }}>CONTRASEÑA INICIAL</label>
              <input className="input" type="password" placeholder="••••••••" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: 11, color: 'var(--text3)', marginBottom: 6 }}>ROL</label>
              <select className="input" value={form.rol} onChange={e => setForm(f => ({ ...f, rol: e.target.value }))}>
                <option value="recepcionista">Recepcionista</option>
                <option value="admin">Administrador</option>
              </select>
            </div>
            {form.rol === 'recepcionista' && (
              <div style={{ gridColumn: '1 / -1' }}>
                <label style={{ display: 'block', fontSize: 11, color: 'var(--text3)', marginBottom: 6 }}>EDIFICIO ASIGNADO</label>
                <select className="input" value={form.edificio_id} onChange={e => setForm(f => ({ ...f, edificio_id: e.target.value }))}>
                  <option value="">Seleccioná un edificio...</option>
                  {edificios.map(e => <option key={e.id} value={e.id}>{e.nombre}</option>)}
                </select>
              </div>
            )}
          </div>
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <button className="btn btn-outline btn-sm" onClick={() => setShowForm(false)}>Cancelar</button>
            <button className="btn btn-gold btn-sm" onClick={handleCreate} disabled={loading}>
              {loading ? 'Creando...' : 'Crear usuario'}
            </button>
          </div>
        </div>
      )}

      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        {usuarios.map((u, i) => (
          <div key={u.id} style={{
            display: 'flex', alignItems: 'center', gap: 16, padding: '16px 20px',
            borderBottom: i < usuarios.length - 1 ? '1px solid var(--border)' : 'none'
          }}>
            <div style={{
              width: 40, height: 40, borderRadius: '50%', background: 'var(--gold-dim)',
              border: '1.5px solid var(--gold)', display: 'flex', alignItems: 'center',
              justifyContent: 'center', color: 'var(--gold)', fontFamily: 'DM Mono, monospace',
              fontSize: 14, fontWeight: 600, flexShrink: 0
            }}>
              {u.nombre[0].toUpperCase()}
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 500, fontSize: 14, marginBottom: 3 }}>{u.nombre}</div>
              <div style={{ fontSize: 12, color: 'var(--text3)', fontFamily: 'DM Mono, monospace' }}>
                {u.email}
              </div>
            </div>
            <span className={`badge ${u.rol === 'admin' ? 'badge-gold' : 'badge-gray'}`}>
              {u.rol === 'admin' ? 'Admin' : 'Recepcionista'}
            </span>
            {u.edificios && (
              <span style={{ fontSize: 12, color: 'var(--text3)' }}>{u.edificios.nombre}</span>
            )}
            <span className={`badge ${u.activo ? 'badge-green' : 'badge-red'}`}>
              {u.activo ? 'Activo' : 'Inactivo'}
            </span>
            <button className="btn btn-ghost btn-sm" onClick={() => handleToggle(u)}>
              {u.activo ? 'Desactivar' : 'Activar'}
            </button>
          </div>
        ))}
      </div>
    </div>
  )
}
